/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sort_ProteinInputs */

const en_sort_protein = /** @type {(inputs: Sort_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Protein`)
};

const de_sort_protein = /** @type {(inputs: Sort_ProteinInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eiweiß`)
};

/**
* | output |
* | --- |
* | "Protein" |
*
* @param {Sort_ProteinInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sort_protein = /** @type {((inputs?: Sort_ProteinInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sort_ProteinInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_sort_protein(inputs)
	return en_sort_protein(inputs)
});